import services from 'services/services';
import * as types from '../types';

// Import helpers
import { checkFetchErrors } from '../helpers_actions/convert_helpers';

// ******************** FETCH CHANNEL MATERIALS ********************
export const fetchChannelMaterials = (uuid) => async (dispatch, getState) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_CHANNEL_MATERIALS_LOADING,
			payload: true
		});

		const response = await services.get(
			`/player/${uuid}/list?with_assets=true`
		);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_CHANNEL_MATERIALS_SUCCESS,
			payload: response.data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_CHANNEL_MATERIALS_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
// ******************** UPDATE / DELETE CHANNEL MATERIALS ********************
export const updateChannelMaterials = (data, type, productId) => ({
	type: types.UPDATE_CHANNEL_MATERIALS,
	payload: { data, type, productId }
});

export const updateChannelMaterialsError = (error) => ({
	type: types.UPDATE_CHANNEL_MATERIALS_ERROR,
	payload: error
});

export const deleteChannelMaterials = (id, type) => ({
	type: types.DELETE_CHANNEL_MATERIALS,
	payload: { id, type }
});

export const deleteChannelMaterialsError = (error) => ({
	type: types.DELETE_CHANNEL_MATERIALS_ERROR,
	payload: error
});

// ******************** ADD VIDEO TO CHANNEL ********************
export const addVideoToChannel = (uuid) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.ADD_VIDEO_TO_CHANNEL_LOADING,
			payload: true
		});

		const resources = {
			product_uuid: uuid,
			product_type: 'channel',
			video_type: 'main'
		};

		const response = await services.post(`/player/video/create`, resources);

		// add empty asset array to response data
		response.data.assets = [];

		// Dispatch an action with data
		dispatch({
			type: types.ADD_VIDEO_TO_CHANNEL_SUCCESS,
			payload: { data: response.data }
		});
	} catch (error) {
		dispatch({
			type: types.ADD_VIDEO_TO_CHANNEL_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
